import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  create_calendar_event_availability_action,
  create_calendar_event_action,
  get_calendar_availability_lists_action,
  get_calendar_event_availability_action,
  get_calendar_event_details_action,
  update_calendar_event_availability_action,
  update_calendar_event_action,
} from "../../../../redux/_actions";
import {
  convertDate,
  dateDiffInDays,
} from "../../../../_helpers/dateFormatter";
import { formValidator } from "../../../../_helpers/validators";
import { formSchema } from "./constants";

function useCreateEvent(props) {
  const [formData, setFormData] = useState({ ...formSchema });
  const [editorOpen, setEditorOpen] = useState(false);
  const [formInputsError, setFormInputsError] = useState({});
  const [calendarAvailabilityLists, setCalendarAvailabilityLists] = useState();
  const [calendarEventAvailability, setCalendarEventAvailability] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { calendarEventData } = useSelector(
    (state) => state.get_calendar_event_details_data_reducer
  );

  const { calendarAvailabilityListsData } = useSelector(
    (state) => state.get_calendar_availability_lists_data_reducer
  );
  const { calendarEventAvailabilityData } = useSelector(
    (state) => state.get_calendar_event_availability_data_reducer
  );
  useEffect(() => {
    callAvailabilityListApi();

    const id = params?.id;
    if (id) {
      callApi(id);
    }
  }, []);

  useEffect(() => {
    const id = params?.id;
    if (id) {
      if (calendarEventData?.data) {
        let data = calendarEventData?.data;
        // data["interview_before"] = dateDiffInDays(
        //   new Date(data["interview_before"])
        // );
        setFormData(calendarEventData?.data);
      }
    }
  }, [calendarEventData]);

  useEffect(() => {
    if (calendarEventData?.data) {
      let data = calendarEventData?.data;

      if (data?.hash_id !== null) {
        callEventAvailabilityApi(data?.hash_id);
      }
    }
  }, [calendarEventData]);

  useEffect(() => {
    if (calendarEventAvailabilityData?.data) {
      setCalendarEventAvailability(calendarEventAvailabilityData?.data);
    }
  }, [calendarEventAvailabilityData]);

  useEffect(() => {
    if (calendarAvailabilityListsData?.data) {
      setCalendarAvailabilityLists(calendarAvailabilityListsData?.data.results);
    }
  }, [calendarAvailabilityListsData]);

  const callApi = async (id) => {
    await dispatch(get_calendar_event_details_action(id));
  };

  const callAvailabilityListApi = async (id) => {
    await dispatch(get_calendar_availability_lists_action());
  };

  const callEventAvailabilityApi = async (id) => {
    await dispatch(get_calendar_event_availability_action(id));
  };

  const onFormInputChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    let data = formData;
    data[name] = value;
    setFormData(data);
  };

  const handleEditorOpen = () => {
    setEditorOpen(!editorOpen);
  };

  const onFormSubmit = async () => {
    const [valid, error] = formValidator(
      formData,
      formSchema,
      "description"
    );

    if (valid) {
      let data = formData;
      var date = new Date();
      data["interview_before"] = convertDate(
        date.setDate(date.getDate() + 100)
      );

      if (data?.id) {
        await dispatch(update_calendar_event_action(data, data.id));
      } else {
        await dispatch(create_calendar_event_action(data));
      }
      navigate("/calender-dashboard", {
        state: {
          activeTab: "Events",
        },
      });
    } else {
      setFormInputsError(error);
    }
  };

  const onAvailabilityChange = async (id) => {
    let data = {
      event: formData?.id,
      availability: id,
    };
    if (formData?.hash_id === null) {
      await dispatch(create_calendar_event_availability_action(data));
    } else {
      await dispatch(
        update_calendar_event_availability_action(formData?.hash_id, data)
      );
    }
  };

  const onCancelClick = () => {
    const id = params?.id;
    if (id)
      navigate("/calender-dashboard", {
        state: {
          activeTab: "Events",
        },
      });
    else
      navigate("/calender-dashboard", {
        state: {
          activeTab: "ScheduledEvents",
        },
      });
  };
  const onAddAvailabilty = () => navigate("/calender-dashboard");
  const onBackHandler = () => {
    navigate("/calender-dashboard", {
      state: {
        activeTab: "Events",
      },
    });
  };
  return {
    formData,
    editorOpen,
    calendarAvailabilityLists,
    calendarEventAvailability,
    formInputsError,

    onFormInputChange,
    handleEditorOpen,
    onFormSubmit,
    onAvailabilityChange,
    onCancelClick,
    onAddAvailabilty,
    onBackHandler,
  };
}

export default useCreateEvent;
